import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/primary_white_logo.svg';
import '../styles/contact.css';

/**
 * Shared card layout for the contact form: logo, title,
 * description, the form, and the legal disclaimer.
 */
export default function ContactShell({ children }) {
  const navigate = useNavigate();

  return (
    <div className="page page--center">
      <div className="panel-card contact-card">
        <button type="button" className="card-logo" onClick={() => navigate('/')} aria-label="Back to home">
          <Logo />
        </button>

        <h2 className="card-title">Professional Investor Interest Form</h2>
        <p className="contact-description">
          Thank you for your interest in Erebus Capital, a quant-driven, multi-strategy investment advisor for professional and institutional investors. Please complete this form to help us assess alignment and begin the qualification process. This is not a public offering or solicitation.
        </p>

        {children}

        <p className="contact-disclaimer">
          This form is for informational and qualification purposes only. It does not constitute an
          offer to sell or a solicitation of an offer to buy any securities. Investment
          opportunities will only be presented through formal offering documents to eligible
          parties.
        </p>
      </div>
    </div>
  );
}
